import { router } from '@inertiajs/react'
import { Badge } from '@/components/ui/badge'
import FdeRecordStatus from '@/frontend/features/Fde/FdeRecordStatus'
import RecordActions from '@/frontend/features/Fde/RecordActions'
import type { FdeCopy, Relationship } from '@/frontend/features/Fde/types'
import { fdeRoutes } from '@/frontend/features/Fde/routes'

export default function RelationshipList({ relationships, projectId, copy, canManage, onEdit }: { relationships: Relationship[]; projectId: string; copy: FdeCopy; canManage: boolean; onEdit: (relationship: Relationship) => void }) {
  function remove(relationship: Relationship) {
    if (window.confirm(copy.common.confirm_delete)) router.delete(`${fdeRoutes.relationships}/${relationship.id}?project_id=${projectId}`, { preserveScroll: true })
  }
  function confirm(relationship: Relationship) {
    router.patch(`${fdeRoutes.relationships}/${relationship.id}?project_id=${projectId}`, { relationship: { status: 'confirmado' } }, { preserveScroll: true })
  }

  if (relationships.length === 0) return <p className="p-6 text-center text-sm text-muted-foreground">{copy.workspace.no_relationships}</p>
  return (
    <div className="divide-y divide-border">
      {relationships.map((relationship) => (
        <article key={relationship.id} className="flex gap-3 px-4 py-3 hover:bg-muted/30">
          <div className="min-w-0 flex-1"><div className="flex flex-wrap items-center gap-1.5 text-sm"><span>{relationship.from.name}</span><Badge variant="secondary">{relationship.verb}</Badge><span>{relationship.to.name}</span><FdeRecordStatus status={relationship.status} proposedLabel={copy.workspace.proposed} confirmedLabel={copy.workspace.confirmed_status} /></div>{relationship.description && <p className="mt-1 line-clamp-2 text-xs leading-5 text-muted-foreground">{relationship.description}</p>}</div>
          {canManage && <RecordActions proposed={relationship.status === 'proposto'} copy={copy} onEdit={() => onEdit(relationship)} onConfirm={() => confirm(relationship)} onDelete={() => remove(relationship)} />}
        </article>
      ))}
    </div>
  )
}
